import React from 'react'
import styles from './RecurringInvoices.module.scss'
import { currencyUtils } from '../../../../../../utils'
import { Header } from 'components'

interface RecurringInvoice {
  label: string
  value: number | string
}

interface RecurringInvoicesProps {
  invoices: RecurringInvoice[]
}

const RecurringInvoices = ({ invoices }: RecurringInvoicesProps) => {
  return (
    invoices.length > 0 && (
      <section className={styles.root}>
        <Header className={styles.header} tag="h4" text="Monthly recurring invoices" />
        <ul>
          {invoices.map((inv, i) => (
            <li key={i}>
              <span>{inv.label}</span>
              <span>{inv.value === 'Set on send' ? inv.value : currencyUtils.formatCurrency(inv.value)}</span>
            </li>
          ))}
        </ul>
      </section>
    )
  )
}

export default RecurringInvoices
